/*
 * @Descripttion: 
 * @Author: xutao
 * @Date: 2020-09-29 09:34:19
 * @LastEditors: xutao
 * @LastEditTime: 2020-12-29 14:03:41
 * @FilePath: \yunjiactivity-h5\src\common\define\errorCodeEnum.js
 */
/**
 * 福袋错误码枚举
 */
export const VIP_CALL_ERROR_CODE_ENUM = {
    /**
     * 正确
     */
    SUCCESS: 0,
    /**
     * 库存不足
     */
    COUPON_NOT_ENOUGH: 100,
    /**
     * 发放失败
     */
    COUPON_SEND_ERROR: 101,
    /**
     * 未命中
     */
    RELATION_REWARD_HIT: 150130,
    /**
     * 自己命中自己
     */
    RELATION_REWARD_SELF: 150131,
    /**
     * 活动已关闭
     */
    RELATION_ACTIVITY_CLOSE: 150132,
    /**
     * 非会员
     */
    // RELATION_NOT_VIP: 150133,
    /**
     * 非自己上级分享
     */
    // RELATION_NOT_HIGHER_SHARE: 150134,
    /**
     * 已经成功获取
     */
    RELATION_HAD_RECEIVE: 150135,
    /**
     * 没中哦！
     */
    RELATION_HAD_RECEIVE_TODAY: 150136,
    /**
     * 好遗憾，没有抽中哦
     */
    RELATION_HAD_HIT: 150137,
    /**
     * 福袋失效
     */
    RELATION_LUCK_BAG_INVALIDATE: 150156,
}